import React, { useEffect, useState } from "react";
import { getPaynlMerchants, updatePaynlMerchant } from "../../PaymentProviders/Paynl/PaynlApi";
import cloudStore from "../../../store/CloudStore";
import { CircularProgress, Divider, TextField, Typography } from "@material-ui/core";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import { Autocomplete } from "@material-ui/lab";
import withIntl from "../../../utils/withIntl";

 function PaynlMerchantSetup(props) {
  const [paynlMerchant, setPaynlMerchant] = useState([]);
  const [availableMerchants, setAvailableMerchants] = useState([]);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  let loading = open && options.length === 0;

  const searchResults = (searchValue) => {
    if (!availableMerchants) {
      return [];
    }
    if (paynlMerchant && searchValue.length === 0) {
      let merchant = availableMerchants.find(
        (merchant) =>
          merchant.serviceId === paynlMerchant.serviceId && merchant.merchantId === paynlMerchant.merchantId
      );
      if (merchant && selectedOption == null) {
        setSelectedOption(merchant);
      }
    }
    return availableMerchants.reduce((options, option) => {
      if (options.length > 9) {
        return options;
      }
      let searchValues = searchValue.split(/\s/);

      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (
            option.serviceName.toLowerCase().includes(value.toLowerCase()) ||
            option.merchantName.toLowerCase().includes(value.toLowerCase())
          ) {
            return true;
          }
          return false;
        })
      ) {
        options.push(option);
      }

      return options;
    }, []);
  };

  useEffect(() => {
    getPaynlMerchants().then((paynlMerchants) => {
      setAvailableMerchants(paynlMerchants);
    });
  }, []);

  useEffect(() => {
    if (
      selectedOption &&
      paynlMerchant?.serviceId !== selectedOption.serviceId &&
      paynlMerchant?.merchantId !== selectedOption.merchantId
    ) {
      props.updatePaynlMerchant(selectedOption);
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const merchants = await searchResults(searchValue);
      if (active) {
        setOptions(merchants);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, availableMerchants]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  if (!availableMerchants) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <AuthorizationWrapper
      permission={"paynl.connect_merchant"}
      child={
        <>
          <Divider />
          <Typography variant={"h6"}>Connect new pin merchant</Typography>
          <Autocomplete
            style={{ width: 300 }}
            open={open}
            onOpen={() => {
              setOpen(true);
            }}
            onClose={() => {
              setOpen(false);
              setSearchValue("");
            }}
            filterOptions={(x) => x}
            onChange={(e, value) => {
              if (value) {
                setSelectedOption(value);
              }
            }}
            onInputChange={(event, value) => {
              setSearchValue(value);
            }}
            getOptionSelected={(option, value) => {
              return option.serviceId === value.serviceId && option.merchantId === value.merchantId;
            }}
            getOptionLabel={(option) => option.merchantName + " - " + option.serviceName}
            options={options}
            loading={loading}
            renderInput={(params) => (
              <TextField
                {...params}
                label={props.intl.formatMessage({ id: "Search" })}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                }}
              />
            )}
          />
        </>
      }
    />
  );
}

export default withIntl(PaynlMerchantSetup)